<template>
  <div>
    <div :class="`wrapper-page${isMenuOpen ? '' : '-closeSidebar'}`">
      <!-- Mobile -->
      <PageSidebarMobile :show="isMenuOpen && currentDevice != 'desktop'" />

      <!-- Desktop -->
      <page-sidebar :isMenuOpen="isMenuOpen" :tooltipType="tooltipType" @toggleMenu="toggleMenu"
        v-if="currentDevice == 'desktop'">
        <template #custom-header>
          <img src="@/core/assets/images/layout/logo-admin.png" alt="Razzil" class="sidebar-logo" />
          <span class="sidebar-title w-50">ZET</span>
        </template>

        <template #list-items>
          <!-- Portada -->
          <router-link :to="{ name: 'dashboard' }" tag="li" exact-active-class="active" class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'home-item'" @mouseleave.native="tooltipType = null" v-if="!showViewAdmin">
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-home-5-line"></i>
              </span>

              <span class="sidebar-item-text">Portada</span>

              <CustomTooltip custom-class="tooltip-sidebar" v-if="!isMenuOpen && tooltipType === 'home-item'"
                text="Portada" />
            </div>
          </router-link>

          <router-link :to="{ name: 'admin-dashboard' }" tag="li" exact-active-class="active"
            class="d-flex sidebar-item" @mouseover.native="tooltipType = 'home-item'"
            @mouseleave.native="tooltipType = null" v-else>
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-home-5-line"></i>
              </span>

              <span class="sidebar-item-text">Portada</span>

              <CustomTooltip custom-class="tooltip-sidebar" v-if="!isMenuOpen && tooltipType === 'home-item'"
                text="Portada" />
            </div>
          </router-link>

          <!-- Reclamaciones -->

          <router-link :to="{ name: 'complaints' }" tag="li" active-class="active" class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'complaint-item'" @mouseleave.native="tooltipType = null"
            v-if="!showViewAdmin">
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-article-line"></i>
              </span>

              <span class="sidebar-item-text">Reclamaciones</span>

              <CustomTooltip custom-class="tooltip-sidebar" v-if="!isMenuOpen && tooltipType === 'complaint-item'"
                text="Reclamaciones" />
            </div>
          </router-link>

          <!-- Locales -->
          <router-link :to="{ name: 'location-list' }" tag="li" active-class="active" class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'locations-item'" @mouseleave.native="tooltipType = null">
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-store-2-line"></i>
              </span>

              <span class="sidebar-item-text">Locales</span>

              <CustomTooltip custom-class="tooltip-sidebar" v-if="!isMenuOpen && tooltipType === 'locations-item'"
                text="Locales" />
            </div>
          </router-link>

          <router-link :to="{ name: 'brands-list' }" tag="li" active-class="active" class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'brands-item'" @mouseleave.native="tooltipType = null"
            v-if="showViewAdmin">
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-price-tag-3-line"></i>
              </span>

              <span class="sidebar-item-text">Marcas</span>

              <CustomTooltip custom-class="tooltip-sidebar" v-if="!isMenuOpen && tooltipType === 'brands-item'"
                text="Marcas" />
            </div>
          </router-link>

          <router-link :to="{ name: 'user-list' }" tag="li" active-class="active" class="d-flex sidebar-item"
            @mouseover.native="tooltipType = 'users-item'" @mouseleave.native="tooltipType = null" v-if="showViewAdmin">
            <div class="d-flex align-items-center">
              <span class="menu-icon">
                <i class="ri-file-user-line"></i>
              </span>

              <span class="sidebar-item-text">Usuarios</span>

              <CustomTooltip custom-class="tooltip-sidebar" v-if="!isMenuOpen && tooltipType === 'users-item'"
                text="Marcas" />
            </div>
          </router-link>
        </template>

        <template #footer>
          <section class="page-sidebar-footer" v-if="!showViewAdmin">
            <router-link :to="{ name: 'general-configuration' }" tag="li" exact-active-class="active"
              class="d-flex sidebar-item sidebar-item-footer"
              @mouseover.native="tooltipType = 'general-configuration-item'" @mouseleave.native="tooltipType = null">
              <div class="d-flex align-items-center">
                <span class="menu-icon">
                  <i class="ri-settings-2-line"></i>
                </span>

                <span class="sidebar-item-text">Configuración general</span>

                <CustomTooltip custom-class="tooltip-sidebar"
                  v-if="!isMenuOpen && tooltipType === 'general-configuration-item'" text="Configuración general" />
              </div>
            </router-link>

            <div class="d-flex justify-content-between align-items-center sidebar-item sidebar-item-footer"
              v-if="isMenuOpen">
              <span class="plan">Plan gratuito</span>

              <router-link to="/" class="text-white plan-link">Modificar</router-link>
            </div>
          </section>
        </template>
      </page-sidebar>

      <div class="wrapper-page__content">
        <page-header />
        <div class="wrapper-page__inner">
          <b-container fluid>
            <slot></slot>
          </b-container>
        </div>
      </div>

      <page-footer />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

import {
  PageSidebar,
  CustomTooltip,
  PageFooter
} from "wize-admin";

import PageHeader from "./PageHeader";
import PageSidebarMobile from "./layout/PageSidebarMobile";

export default {
  name: "PageBase",
  components: {
    PageHeader,
    PageSidebar,
    PageFooter,
    CustomTooltip,
    PageSidebarMobile
  },
  data() {
    return {
      matchMediaMd: window.matchMedia("(max-width: 768px)"),
      tooltipType: null,
    };
  },
  mounted() {
    this.calcResize();
  },
  computed: {
    ...mapGetters({
      currentSubmenu: "app/getCurrentSubmenu",
      isMenuOpen: "app/isMenuOpen",
      currentDevice: "app/getCurrentDevice",
    }),
    showViewAdmin() {
      return this.$route.path.includes("admin")
    }
  },
  methods: {
    ...mapMutations({
      setCurrentSubmenu: "app/setCurrentSubmenu",
      setMenu: "app/setMenu",
      toggleMenu: "app/toggleMenu",
    }),
    setCurrentDevice() {
      if (screen.width < 992) {
        this.$store.commit("app/setCurrentDevice", "mobile");
        this.toggleMenu(false);
      } else {
        this.$store.commit("app/setCurrentDevice", "desktop");
        this.toggleMenu(true);
      }
    },
    calcResize() {
      this.setCurrentDevice();

      this.lastWidth = window.innerWidth;

      window.addEventListener("resize", () => {
        const currentWidth = window.innerWidth;

        if (currentWidth !== this.lastWidth) {
          this.setCurrentDevice();
          this.lastWidth = currentWidth;
        }
      });
    },
    isMatchMedia() {
      if (this.matchMediaMd.matches) {
        this.setMenu(false);
      } else {
        this.setMenu(true);
      }
    },
    isCurrent(submenu) {
      return this.currentSubmenu.includes(submenu);
    },
  },
  created() {
    this.matchMediaMd.addListener(this.isMatchMedia);
  },
};
</script>

<style lang="stylus">
</style>